import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import classnames from "classnames";
import { Preloader } from "../../../common/index.js";
import { Icon } from "../../../../Icon/index.js";
import SelectInput_styles from "../../SelectInput.styles.js";
import { Group } from "../common/index.js";
import { PopupIcon } from "../../PopupIcon/index.js";
import { Option } from "./Option/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function MultipleAutocomplete_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else MultipleAutocomplete_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const MultipleAutocomplete = (t0)=>{
    const $ = c(89);
    let emptyOption;
    let handlePopoverOpen;
    let helperText;
    let inputId;
    let inputValue;
    let isThereSomeGroup;
    let items;
    let label;
    let onChange;
    let onFocus;
    let placeholder;
    let renderOption;
    let rest;
    let setInputValue;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let value;
    if ($[0] !== t0) {
        const { label: t5, value: t6, items: t7, onChange: t8, disabled: t9, placeholder: t10, testId: t11, clearable: t12, loading: t13, error: t14, helperText: t15, renderOption: t16, emptyOption: t17, inputValue: t18, setInputValue: t19, isThereSomeGroup: t20, inputId: t21, handlePopoverOpen: t22, valueBadge, valueColorIndicator, onFocus: t23 } = t0, t24 = _object_without_properties(t0, [
            "label",
            "value",
            "items",
            "onChange",
            "disabled",
            "placeholder",
            "testId",
            "clearable",
            "loading",
            "error",
            "helperText",
            "renderOption",
            "emptyOption",
            "inputValue",
            "setInputValue",
            "isThereSomeGroup",
            "inputId",
            "handlePopoverOpen",
            "valueBadge",
            "valueColorIndicator",
            "onFocus"
        ]);
        label = t5;
        value = t6;
        items = t7;
        onChange = t8;
        t1 = t9;
        placeholder = t10;
        testId = t11;
        t2 = t12;
        t3 = t13;
        t4 = t14;
        helperText = t15;
        renderOption = t16;
        emptyOption = t17;
        inputValue = t18;
        setInputValue = t19;
        isThereSomeGroup = t20;
        inputId = t21;
        handlePopoverOpen = t22;
        onFocus = t23;
        rest = t24;
        $[0] = t0;
        $[1] = emptyOption;
        $[2] = handlePopoverOpen;
        $[3] = helperText;
        $[4] = inputId;
        $[5] = inputValue;
        $[6] = isThereSomeGroup;
        $[7] = items;
        $[8] = label;
        $[9] = onChange;
        $[10] = onFocus;
        $[11] = placeholder;
        $[12] = renderOption;
        $[13] = rest;
        $[14] = setInputValue;
        $[15] = t1;
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = testId;
        $[20] = value;
    } else {
        emptyOption = $[1];
        handlePopoverOpen = $[2];
        helperText = $[3];
        inputId = $[4];
        inputValue = $[5];
        isThereSomeGroup = $[6];
        items = $[7];
        label = $[8];
        onChange = $[9];
        onFocus = $[10];
        placeholder = $[11];
        renderOption = $[12];
        rest = $[13];
        setInputValue = $[14];
        t1 = $[15];
        t2 = $[16];
        t3 = $[17];
        t4 = $[18];
        testId = $[19];
        value = $[20];
    }
    const disabled = void 0 === t1 ? false : t1;
    const clearable = void 0 === t2 ? false : t2;
    const loading = void 0 === t3 ? false : t3;
    const error = void 0 === t4 ? false : t4;
    const { classes } = SelectInput_styles();
    let t5;
    if ($[21] !== items || $[22] !== value) {
        let t6;
        if ($[24] !== value) {
            t6 = (opt)=>{
                var _ref;
                return null != (_ref = null == value ? void 0 : value.includes(opt.value)) ? _ref : [];
            };
            $[24] = value;
            $[25] = t6;
        } else t6 = $[25];
        t5 = items.filter(t6);
        $[21] = items;
        $[22] = value;
        $[23] = t5;
    } else t5 = $[23];
    const [selectedValues, setSelectedValues] = useState(t5);
    const t6 = !!renderOption;
    let t7;
    if ($[26] !== classes.autocompleteList || $[27] !== classes.list || $[28] !== classes.longList || $[29] !== t6) {
        t7 = classnames(classes.list, classes.autocompleteList, {
            [classes.longList]: t6
        });
        $[26] = classes.autocompleteList;
        $[27] = classes.list;
        $[28] = classes.longList;
        $[29] = t6;
        $[30] = t7;
    } else t7 = $[30];
    let t8;
    if ($[31] !== t7) {
        t8 = {
            paper: t7
        };
        $[31] = t7;
        $[32] = t8;
    } else t8 = $[32];
    const inputClasses = t8;
    let t9;
    if ($[33] !== loading) {
        t9 = loading ? {
            slotProps: {
                input: {
                    endAdornment: /*#__PURE__*/ jsx(Preloader, {})
                }
            }
        } : {};
        $[33] = loading;
        $[34] = t9;
    } else t9 = $[34];
    const loadingInputProps = t9;
    const groupBy = _temp;
    let t10;
    if ($[35] !== isThereSomeGroup) {
        t10 = isThereSomeGroup ? {
            groupBy
        } : {};
        $[35] = isThereSomeGroup;
        $[36] = t10;
    } else t10 = $[36];
    const groupProps = t10;
    let t11;
    if ($[37] !== setInputValue) {
        t11 = (_, nextValue, reason)=>{
            if ("input" === reason) setInputValue(nextValue);
        };
        $[37] = setInputValue;
        $[38] = t11;
    } else t11 = $[38];
    const handleInputChange = t11;
    let t12;
    if ($[39] !== onChange) {
        t12 = (__0, nextValue_0)=>{
            setSelectedValues(nextValue_0);
            onChange(nextValue_0.map(_temp2));
        };
        $[39] = onChange;
        $[40] = t12;
    } else t12 = $[40];
    const handleChange = t12;
    let t13;
    if ($[41] !== selectedValues || $[42] !== setInputValue) {
        t13 = ()=>{
            selectedValues.length ? setInputValue(selectedValues.map(_temp3).join(", ")) : setInputValue("");
        };
        $[41] = selectedValues;
        $[42] = setInputValue;
        $[43] = t13;
    } else t13 = $[43];
    const handleOnBlur = t13;
    let t14;
    if ($[44] !== items || $[45] !== setInputValue || $[46] !== value) {
        t14 = ()=>{
            setInputValue(items.filter((item_1)=>null == value ? void 0 : value.includes(item_1.value)).map(_temp4).join(", "));
        };
        $[44] = items;
        $[45] = setInputValue;
        $[46] = value;
        $[47] = t14;
    } else t14 = $[47];
    let t15;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = [];
        $[48] = t15;
    } else t15 = $[48];
    useEffect(t14, t15);
    let t16;
    if ($[49] !== items || $[50] !== value) {
        let t17;
        if ($[52] !== value) {
            t17 = (option)=>null == value ? void 0 : value.includes(option.value);
            $[52] = value;
            $[53] = t17;
        } else t17 = $[53];
        t16 = items.filter(t17);
        $[49] = items;
        $[50] = value;
        $[51] = t16;
    } else t16 = $[51];
    const t17 = loading ? "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." : inputValue;
    const t18 = disabled || loading;
    const t19 = !clearable;
    let t20;
    let t21;
    if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ jsx(PopupIcon, {
            mx: "12"
        });
        t21 = /*#__PURE__*/ jsx(Icon, {
            name: "dismiss_substract",
            color: "stroke.secondary",
            size: "24"
        });
        $[54] = t20;
        $[55] = t21;
    } else {
        t20 = $[54];
        t21 = $[55];
    }
    const t22 = emptyOption || "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E";
    let t23;
    if ($[56] !== setInputValue) {
        t23 = ()=>setInputValue("");
        $[56] = setInputValue;
        $[57] = t23;
    } else t23 = $[57];
    let t24;
    if ($[58] !== classes.inputRoot || $[59] !== error || $[60] !== handlePopoverOpen || $[61] !== helperText || $[62] !== inputId || $[63] !== label || $[64] !== loadingInputProps || $[65] !== placeholder || $[66] !== rest) {
        t24 = (params_0)=>/*#__PURE__*/ jsx(TextField, _object_spread_props(_object_spread({}, rest, params_0, loadingInputProps), {
                id: inputId,
                onClick: handlePopoverOpen,
                classes: {
                    root: `${classes.inputRoot} aqa_select`
                },
                variant: "outlined",
                placeholder: placeholder || label,
                error: error,
                helperText: helperText
            }));
        $[58] = classes.inputRoot;
        $[59] = error;
        $[60] = handlePopoverOpen;
        $[61] = helperText;
        $[62] = inputId;
        $[63] = label;
        $[64] = loadingInputProps;
        $[65] = placeholder;
        $[66] = rest;
        $[67] = t24;
    } else t24 = $[67];
    let t25;
    if ($[68] !== inputValue || $[69] !== renderOption || $[70] !== value) {
        t25 = (props, option_2)=>/*#__PURE__*/ jsx(Option, {
                value: value,
                inputValue: inputValue,
                renderOption: renderOption,
                optionProps: props,
                option: option_2
            });
        $[68] = inputValue;
        $[69] = renderOption;
        $[70] = value;
        $[71] = t25;
    } else t25 = $[71];
    let t26;
    if ($[72] !== groupProps || $[73] !== handleChange || $[74] !== handleInputChange || $[75] !== handleOnBlur || $[76] !== inputClasses || $[77] !== items || $[78] !== onFocus || $[79] !== t16 || $[80] !== t17 || $[81] !== t18 || $[82] !== t19 || $[83] !== t22 || $[84] !== t23 || $[85] !== t24 || $[86] !== t25 || $[87] !== testId) {
        t26 = /*#__PURE__*/ jsx(Autocomplete, _object_spread_props(_object_spread({}, groupProps), {
            multiple: true,
            disableCloseOnSelect: true,
            "data-testid": testId,
            classes: inputClasses,
            value: t16,
            inputValue: t17,
            options: items,
            disabled: t18,
            disableClearable: t19,
            popupIcon: t20,
            clearIcon: t21,
            noOptionsText: t22,
            renderTags: _temp5,
            getOptionDisabled: _temp6,
            renderGroup: _temp7,
            getOptionLabel: _temp8,
            onInputChange: handleInputChange,
            onClose: t23,
            onChange: handleChange,
            onFocus: onFocus,
            onBlur: handleOnBlur,
            renderInput: t24,
            renderOption: t25
        }));
        $[72] = groupProps;
        $[73] = handleChange;
        $[74] = handleInputChange;
        $[75] = handleOnBlur;
        $[76] = inputClasses;
        $[77] = items;
        $[78] = onFocus;
        $[79] = t16;
        $[80] = t17;
        $[81] = t18;
        $[82] = t19;
        $[83] = t22;
        $[84] = t23;
        $[85] = t24;
        $[86] = t25;
        $[87] = testId;
        $[88] = t26;
    } else t26 = $[88];
    return t26;
};
function _temp(t0) {
    const { group } = t0;
    return group || "\u0417\u0430\u044F\u0432\u043A\u0438 \u0431\u0435\u0437 \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438 \u043F\u043E \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044F\u043C";
}
function _temp2(item) {
    return item.value;
}
function _temp3(item_0) {
    return item_0.label;
}
function _temp4(item_2) {
    return item_2.label;
}
function _temp5() {
    return null;
}
function _temp6(option_0) {
    return !!option_0.disabled;
}
function _temp7(params) {
    return /*#__PURE__*/ jsx(Group, _object_spread({}, params));
}
function _temp8(option_1) {
    return option_1.label;
}
export { MultipleAutocomplete };
